import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ElofizetoCegService } from '../../../services/elofizeto-ceg.service';
import { ElofizetoCegVmForSelect } from '../../../models/elofizetoCeg.model';

@Component({
    selector: 'rendelo-ceg-selector',
    standalone: true,
    imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
    templateUrl: './ceg-selector.component.html',
    styleUrl: './ceg-selector.component.scss'
})
export class CegSelectorComponent implements OnInit {
    private elofizetoCegService = inject(ElofizetoCegService);
    private router = inject(Router);
    private route = inject(ActivatedRoute);

    cegek: ElofizetoCegVmForSelect[] = [];
    loading = true;
    error: string | null = null;

    ngOnInit(): void {
        this.loadCegek();
    }

    loadCegek(): void {
        this.loading = true;
        this.error = null;

        this.elofizetoCegService.getElofizetoCegek().subscribe({
            next: (cegek) => {
                this.cegek = cegek;
                this.loading = false;
            },
            error: (err) => {
                this.error = 'Hiba történt a cégek betöltése közben.';
                this.loading = false;
                console.error('Error loading cegek:', err);
            }
        });
    }

    selectCeg(ceg: ElofizetoCegVmForSelect): void {
        this.elofizetoCegService.setSelectedCeg(ceg.uniqueId);
        const returnUrl = this.route.snapshot.queryParams['returnUrl'];
        this.router.navigateByUrl(returnUrl || '/');
    }
}
